// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"72":"f8396966","874":"ab1770bb"}[chunkId] + ".js";
};